export default __webpack_public_path__ + "media/zurb/img/home/home-tool-foundation-8a6ae8b508500740e08c28081f625d1d.png";